<template>
  <div class="vc-carousel">
    <div class="vc-carousel__content">
      <ul :style="{ transform: transformStyle }">
        <slot></slot>
      </ul>
      <div class="vc-carousel__dots">
        <span
          v-for="(dot, index) in totalSlides"
          :key="index"
          :class="{ active: index === activeSlide }"
          @click="goToSlide(index)"
        ></span>
      </div>
      <div class="vc-carousel__nav">
        <div
          class="vc-button-carousel"
          :class="{ 'is-disabled': isDisabled }"
          type="default"
          @click="voltarCarousel"
        >
          Voltar
        </div>
        <div
          class="vc-button-carousel primary"
          type="primary"
          @click="continuarCarousel"
        >
          {{ primaryLabel }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, Ref, ref, watch } from "vue";

const emit = defineEmits<{
  (e: string): void;
}>();

const isModalVisible = inject("isModalVisible") as Ref<boolean>;
const activeSlide = ref(0);
const totalSlides = ref(3);

const primaryLabel = computed(() =>
  activeSlide.value === 2 ? "Fechar" : "Continuar"
);

const transformStyle = computed(
  () => `translateX(-${activeSlide.value * 100}%)`
);
const isDisabled = computed(() => activeSlide.value === 0);

watch(isModalVisible, () => {
  activeSlide.value = 0;
});

const goToSlide = (index: number) => {
  activeSlide.value = index;
};

const voltarCarousel = () => {
  if (activeSlide.value > 0) {
    activeSlide.value = activeSlide.value - 1;
  }
};

const continuarCarousel = () => {
  if (activeSlide.value < 2) {
    activeSlide.value = activeSlide.value + 1;

    return;
  }

  if (isModalVisible) {
    isModalVisible.value = false;

    emit("close");
  }
};
</script>

<style lang="scss">
$azul: _map.get(
  $map: $azulPrincipal,
  $key: 700
);

.vc-carousel {
  &__content {
    position: relative;
    overflow: hidden;

    ul {
      display: flex;
      transition: transform 0.5s ease-in-out;
      align-items: center;
      gap: 25px;

      li {
        list-style: none;
        min-width: 100%;
        box-sizing: border-box;
      }
    }
  }

  &__dots {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: -1.7rem;

    span {
      width: 16px;
      height: 16px;
      margin: 0 5px;
      background: _map.get($map: $neutro, $key: 50);
      border: 1px solid _map.get($map: $neutro, $key: 300);
      border-radius: 100px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        background: _map.get($map: $neutro, $key: 200);
      }

      &.active {
        width: 32px;
        height: 16px;
        background-color: $azul;

        &:hover {
          background: _map.get($map: $azulPrincipal, $key: 800);
        }
      }
    }
  }

  &__nav {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;

    .vc-button-carousel {
      background: #fff;
      color: _map.get($map: $neutro, $key: 600);
      border: 1px solid _map.get($map: $neutro, $key: 200);
      font-size: 0.875rem;
      line-height: 1rem;
      border-radius: 5px;
      display: inline-block;
      padding: 8px;
      transition: 0.2s;
      cursor: pointer;

      &:hover {
        background: _map.get($map: $neutro, $key: 200);
      }

      &.primary {
        background: $azul;
        color: #fff;

        &:hover {
          background: _map.get($map: $azulPrincipal, $key: 800);
        }
      }

      &.is-disabled {
        cursor: not-allowed;
        background: _map.get($map: $neutro, $key: 200);
      }
    }
  }
}
</style>
